import volume from "./volume.vue"

const Volume = {
  install(Vue) {
    Vue.component("volume", volume)
  }
}

export default Volume
